
import Vue from 'vue'

export default Vue.extend({
  props: {
    capitalize: {
      default: true,
      type: Boolean,
    },
    center: {
      default: false,
      type: Boolean,
    },
  },
})
